import React, { useState, useEffect } from 'react';
import { getWorkerStatus } from '../services/api';
import './WorkerStatus.css';

const WorkerStatus = () => {
    const [status, setStatus] = useState(null);

    useEffect(() => {
        let mounted = true;
        let lastKnown = null;

        const fetchStatus = async () => {
            const data = await getWorkerStatus();
            if (!mounted) return;

            if (data && data.counts) {
                const { active, waiting } = data.counts;
                if (active > 0 || waiting > 0) {
                    lastKnown = data.counts;
                    setStatus(data.counts);
                    return;
                }
            }

            // If fetch failed or counts are zero, keep last known non-empty state
            if (lastKnown) {
                setStatus(lastKnown);
            } else {
                setStatus(null);
            }
        };

        // Initial fetch
        fetchStatus();

        // Poll every 10 seconds (reduced frequency)
        const interval = setInterval(fetchStatus, 10000);

        return () => { mounted = false; clearInterval(interval); };
    }, []);

    if (!status) return null;

    return (
        <div className="worker-status">
            <span className="worker-icon">⚙️</span>
            <div className="worker-info">
                <span className="worker-title">AI Vision Worker</span>
                <span className="worker-desc">
                    Processing: <strong>{status.active}</strong> | Queued: <span className="worker-count">{status.waiting}</span>
                </span>
            </div>
        </div>
    );
};

export default WorkerStatus;
